import { IAtitudeLegenda } from "@deltasge/marauders-map";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import React, { FC } from "react";

export const AtitudesComponent: FC<{
  qtdeEtapas: number;
  nomeEtapa: string;
  etapaAtual: number;
  etapa: number;
  atitudes: IAtitudeLegenda[];
  value: string;
  setValue: (value: string) => void;
}> = ({
  nomeEtapa,
  qtdeEtapas,
  etapaAtual,
  etapa,
  atitudes,
  value,
  setValue,
}) => {
  return (
    <FormControl size="small">
      {qtdeEtapas > 1 && (
        <FormLabel>{`${
          qtdeEtapas == 1 ? etapaAtual : etapa + 1
        }º ${nomeEtapa}`}</FormLabel>
      )}
      <RadioGroup
        row
        value={value}
        onChange={({ target: { value } }) => setValue(value)}
        onClick={(e) => {
          const { value: currValue, checked } = e.target as EventTarget &
            HTMLInputElement;
          if (checked && value == currValue) {
            setValue("");
          }
        }}
      >
        {atitudes.map((atitude) => (
          <Tooltip
            title={atitude.descricao}
            key={`atitude-${etapa}-${atitude.id}`}
          >
            <FormControlLabel
              value={atitude.codigo}
              control={<Radio />}
              label={atitude.legenda}
            />
          </Tooltip>
        ))}
      </RadioGroup>
    </FormControl>
  );
};
